import { render, staticRenderFns } from "./ConfiguracaoCamposObrigatoriosProdutoModal.vue?vue&type=template&id=0649824e&scoped=true"
import script from "./ConfiguracaoCamposObrigatoriosProdutoModal.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoCamposObrigatoriosProdutoModal.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracaoCamposObrigatoriosProdutoModal.vue?vue&type=style&index=0&id=0649824e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0649824e",
  null
  
)

export default component.exports